import { Node_Type } from '@wix/ricos';
import type { Node, VideoData, GalleryData, GIFData, ImageData } from '@wix/ricos';

const getImageURL = (entityData?: ImageData) => {
  const url = entityData?.image?.src?.id;
  if (!url) {
    return;
  }
  return `https://static.wixstatic.com/media/${url.replace('media/', '')}`;
};

const getVideoURL = (entityData?: VideoData) => {
  const thumbnailURL = entityData?.thumbnail?.src?.url;
  if (!thumbnailURL) {
    return;
  }
  return thumbnailURL.startsWith('media/')
    ? `https://static.wixstatic.com/${thumbnailURL}`
    : thumbnailURL;
};

const getImagesUrlsFromGallery = (entityData?: GalleryData) => {
  if (entityData?.items === undefined) {
    return;
  }
  return entityData?.items.map(
    (item) => `https://static.wixstatic.com/media/${item?.image?.media?.src?.url}`,
  );
};

const getGifURL = (entityData?: GIFData) => {
  const videoThumbnailUrl = entityData?.original?.still;
  if (!videoThumbnailUrl) {
    return;
  }
  return videoThumbnailUrl;
};

const processNode = (node: Node, mediaURLs: string[]) => {
  switch (node.type) {
    case Node_Type.VIDEO: {
      const videoURL = getVideoURL(node.videoData);
      if (videoURL) {
        mediaURLs.push(videoURL);
      }
      break;
    }
    case Node_Type.IMAGE: {
      const imageURL = getImageURL(node.imageData);
      if (imageURL) {
        mediaURLs.push(imageURL);
      }
      break;
    }
    case Node_Type.GALLERY: {
      const galleryUrls = getImagesUrlsFromGallery(node.galleryData);
      if (galleryUrls) {
        mediaURLs.push(...galleryUrls);
      }
      break;
    }
    case Node_Type.GIF: {
      const gifURL = getGifURL(node.gifData);
      if (gifURL) {
        mediaURLs.push(gifURL);
      }
      break;
    }
  }

  if (node.nodes && node.nodes.length > 0) {
    for (const childNode of node.nodes) {
      processNode(childNode, mediaURLs);
    }
  }
};

export const extractMediaUrls = (nodes: Node[]) => {
  const mediaURLs: string[] = [];
  if (!nodes) {
    return;
  }

  for (const node of nodes) {
    processNode(node, mediaURLs);
  }

  return mediaURLs;
};
